import { numberWithCommas } from 'common/utils/app.utils';
import { CONFIGURATION_TYPE, MEDIA_TYPES_OTC } from '../configure-plan-pricing-constant';
import React from 'react';
import warningAlert from '../.../../../../../assests/svg/warning-alert.svg';
import Tooltip from 'common/components/tooltip-component/tooltip-component';
import { CELLTYPE_ENUM, SORTTYPE_ENUM } from 'common/components/table/table.constant';
import { TableCheckBox } from 'common/components/table/TableCheckBox';
import { isNLD_OR_LL } from 'common/constants/app.constants';
import { MEDIA_TYPES } from 'dedicated/components/choose-plan/plan.service';

const isMobile = () => {
  var mobileCheck = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return mobileCheck.Android() || mobileCheck.BlackBerry() || mobileCheck.iOS() || mobileCheck.Opera() || mobileCheck.Windows();
    }
  };
  return mobileCheck.any() ? true : false;
};

export const paginationLength = isMobile() ? 4 : 10;

export const ruppeeFormatter = (value) => {
  return <div className="no_wrap"> {value ? `₹ ${numberWithCommas(value)}` : 'N/A'} </div>;
};

const subCellConfigurationType = ({ value, rawContent }) => {
  if (value && rawContent) {
    let icon;
    let asterik;
    const service = rawContent.service;
    const ipType = rawContent.standardIp ? ' & Standard IP' : ' & Non-Standard IP';
    const subValue = service + ipType;
    if (value !== CONFIGURATION_TYPE.DEFAULT) {
      icon = rawContent.service !== 'MANAGED' ? <img alt="cross icon" src={warningAlert} /> : '';
      asterik = rawContent.standardIp ? <span className="error">*</span> : '';
    }

    return (
      <div className="subvalue">
        {icon && icon}
        {subValue}
        {asterik && asterik}
      </div>
    );
  }
  return 'N/A';
};

const getPoleTowerHeight = (rowData) => {
  const selectedMedia = rowData?.rawContent?.selectedMedia?.[0];
  const isRFMedia = selectedMedia?.media === MEDIA_TYPES.RF_P2P;
  return isRFMedia ? selectedMedia?.rfTowerHeight : '';
};

const subCellConfigurationTypeForMediaType = (value, rowData) => {
  const MEDIA_TEXT_ENUM = {
    [MEDIA_TYPES_OTC.OFFNET]: 'CAPEX may apply',
    [MEDIA_TYPES_OTC.THIRD_PARTY]: 'Third party charges to apply'
  };
  const isMediaOTC = [MEDIA_TYPES_OTC.OFFNET, MEDIA_TYPES_OTC.THIRD_PARTY].includes(value);
  let renderMedia;
  if (isMediaOTC) {
    const text = MEDIA_TEXT_ENUM[value];
    renderMedia = (
      <>
        <img alt="cross icon" src={warningAlert} />
        <span className="warning-text">{text}</span>
      </>
    );
  }
  return (
    <div className="subvalue">
      {renderMedia}
      {getPoleTowerHeight(rowData)}
    </div>
  );
};

const getRowSpanForVPN = ({ rawContent: { dualLastMile } } = {}) => {
  return dualLastMile ? 2 : 0;
};

export const BULK_UPGRADE_PNQ_HEADER = [
  {
    headerName: 'Circuit ID',
    isSort: true,
    key: 'lineItemId',
    cellType: CELLTYPE_ENUM.LINK,
    sortKey: 'LOCATION_ID',
    sortType: SORTTYPE_ENUM.ASCENDING
  },
  {
    headerName: 'Installation Address (Branch Code)',
    isSort: false,
    sortType: null,
    key: 'installationAddress',
    subCell: ({ branchCode }) => <div className="subvalue">Branch Code: {branchCode}</div>,
    formatter: ({ address }) => address
  },
  {
    headerName: 'Required Bandwidth',
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'BANDWIDTH',
    key: 'bandwidth'
  },
  {
    headerName: 'Required Service Type',
    isSort: false,
    sortType: null,
    key: 'configurationType',
    subCell: ({ subData }) => <div className="subvalue">{subData}</div>,
    formatter: ({ data }) => data
  },
  {
    headerName: 'Media Type',
    isSort: false,
    sortType: null,
    key: 'mediaType',
    subCell: subCellConfigurationTypeForMediaType
  },
  {
    headerName: 'Contract Period',
    isSort: false,
    sortType: null,
    key: 'contractPeriod'
  },
  {
    headerName: <Tooltip message={'Annual Recurring Charge'}>ARC</Tooltip>,
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'RECURRING_PRICE',
    key: 'arp',
    formatter: ruppeeFormatter
  },
  {
    headerName: <Tooltip message={'One Time Charge'}>OTC</Tooltip>,
    isSort: false,
    sortType: null,
    key: 'otc',
    formatter: ruppeeFormatter
  }
];

export const DI_VPN_HEADERS = [
  {
    headerName: '',
    key: 'checkBox',
    cellType: CELLTYPE_ENUM.CHECKBOX,
    formatter: TableCheckBox,
    rowSpan: getRowSpanForVPN
  },
  {
    headerName: 'Link ID',
    isSort: true,
    key: 'lineItemId',
    cellType: CELLTYPE_ENUM.LINK,
    sortKey: 'LOCATION_ID',
    sortType: SORTTYPE_ENUM.ASCENDING,
    rowSpan: getRowSpanForVPN
  },
  {
    headerName: 'Installation Address',
    isSort: false,
    sortType: null,
    key: 'installationAddress',
    subCell: ({ branchCode }) => <div className="subvalue">Branch Code: {branchCode}</div>,
    formatter: ({ address }) => address,
    rowSpan: getRowSpanForVPN
  },
  {
    headerName: 'Site Type',
    isSort: false,
    key: 'siteType'
  },
  {
    headerName: 'Bandwidth',
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'BANDWIDTH',
    key: 'bandwidth'
  },
  {
    headerName: 'Configuration Type',
    isSort: false,
    sortType: null,
    key: 'configurationType',
    subCell: subCellConfigurationType,
    formatter: ({ value }) => value
  },
  {
    headerName: 'Media Type',
    isSort: false,
    sortType: null,
    key: 'mediaType',
    subCell: subCellConfigurationTypeForMediaType
  },
  {
    headerName: 'Contract Period',
    isSort: false,
    sortType: null,
    key: 'contractPeriod'
  },
  {
    headerName: <Tooltip message={'Annual Recurring Charge'}>ARC</Tooltip>,
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'RECURRING_PRICE',
    key: 'arp',
    formatter: ruppeeFormatter
  },
  {
    headerName: <Tooltip message={'One Time Charge'}>OTC</Tooltip>,
    isSort: false,
    sortType: null,
    key: 'otc',
    formatter: ruppeeFormatter
  }
];

export const PRE_ORDER_DI_VPN_HEADERS = [
  {
    headerName: '',
    key: 'checkBox',
    cellType: CELLTYPE_ENUM.CHECKBOX,
    formatter: TableCheckBox,
    rowSpan: getRowSpanForVPN
  },
  {
    headerName: 'Link ID',
    isSort: true,
    key: 'lineItemId',
    cellType: CELLTYPE_ENUM.LINK,
    sortKey: 'LOCATION_ID',
    sortType: SORTTYPE_ENUM.ASCENDING,
    rowSpan: getRowSpanForVPN
  },
  {
    headerName: 'Installation Address',
    isSort: false,
    sortType: null,
    key: 'installationAddress',
    subCell: ({ branchCode }) => <div className="subvalue">Branch Code: {branchCode}</div>,
    formatter: ({ address }) => address,
    rowSpan: getRowSpanForVPN
  },
  {
    headerName: 'Site Type',
    isSort: false,
    key: 'siteType'
  },
  {
    headerName: 'Bandwidth',
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'BANDWIDTH',
    key: 'bandwidth'
  },
  {
    headerName: 'Configuration Type',
    isSort: false,
    sortType: null,
    key: 'configurationType',
    subCell: subCellConfigurationType,
    formatter: ({ value }) => value
  },
  {
    headerName: 'Media Type',
    isSort: false,
    sortType: null,
    key: 'mediaType',
    subCell: subCellConfigurationTypeForMediaType
  },
  // {
  //   headerName: 'Contract Period',
  //   isSort: false,
  //   sortType: null,
  //   key: 'contractPeriod'
  // },
  {
    headerName: <Tooltip message={'Annual Recurring Charge'}>ARC</Tooltip>,
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'RECURRING_PRICE',
    key: 'arp',
    formatter: ruppeeFormatter
  },
  {
    headerName: <Tooltip message={'One Time Charge'}>OTC</Tooltip>,
    isSort: false,
    sortType: null,
    key: 'otc',
    formatter: ruppeeFormatter
  },
  {
    headerName: 'Pre Order Period',
    isSort: false,
    sortType: null,
    key: 'preOrderDuration'
  }
];

export const PRE_ORDER_UPGRADE_DI_VPN_HEADERS = [
  {
    headerName: 'Link ID',
    isSort: true,
    key: 'lineItemId',
    cellType: CELLTYPE_ENUM.LINK,
    sortKey: 'LOCATION_ID',
    sortType: SORTTYPE_ENUM.ASCENDING,
    rowSpan: getRowSpanForVPN
  },
  {
    headerName: 'Installation Address',
    isSort: false,
    sortType: null,
    key: 'installationAddress',
    subCell: ({ branchCode }) => <div className="subvalue">Branch Code: {branchCode}</div>,
    formatter: ({ address }) => address,
    rowSpan: getRowSpanForVPN
  },
  {
    headerName: 'Site Type',
    isSort: false,
    key: 'siteType'
  },
  {
    headerName: 'Bandwidth',
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'BANDWIDTH',
    key: 'bandwidth'
  },
  {
    headerName: 'Configuration Type',
    isSort: false,
    sortType: null,
    key: 'configurationType',
    subCell: subCellConfigurationType,
    formatter: ({ value }) => value
  },
  {
    headerName: 'Media Type',
    isSort: false,
    sortType: null,
    key: 'mediaType',
    subCell: subCellConfigurationTypeForMediaType
  },
  // {
  //   headerName: 'Contract Period',
  //   isSort: false,
  //   sortType: null,
  //   key: 'contractPeriod'
  // },
  {
    headerName: <Tooltip message={'Annual Recurring Charge'}>ARC</Tooltip>,
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'RECURRING_PRICE',
    key: 'arp',
    formatter: ruppeeFormatter
  },
  {
    headerName: <Tooltip message={'One Time Charge'}>OTC</Tooltip>,
    isSort: false,
    sortType: null,
    key: 'otc',
    formatter: ruppeeFormatter
  },
  {
    headerName: 'Pre Order Period',
    isSort: false,
    sortType: null,
    key: 'preOrderDuration'
  }
];

export const NLD_HEADERS = [
  {
    headerName: '',
    key: 'checkBox',
    cellType: CELLTYPE_ENUM.CHECKBOX,
    formatter: TableCheckBox,
    rowSpan: () => {
      return 2;
    }
  },
  {
    headerName: 'Link ID',
    isSort: false,
    key: 'lineItemId',
    cellType: CELLTYPE_ENUM.LINK,
    sortKey: 'LOCATION_ID',
    sortType: SORTTYPE_ENUM.ASCENDING,
    rowSpan: () => {
      return 2;
    }
  },
  {
    headerName: 'Bandwidth',
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'BANDWIDTH',
    key: 'bandwidth',
    rowSpan: () => {
      return 2;
    }
  },
  {
    headerName: 'Contract Period',
    isSort: false,
    sortType: null,
    key: 'contractPeriod',
    rowSpan: () => {
      return 2;
    }
  },
  {
    headerName: 'Site Type',
    isSort: false,
    key: 'siteType'
  },
  {
    headerName: 'Installation Address',
    isSort: false,
    sortType: null,
    key: 'installationAddress',
    subCell: ({ branchCode }) => <div className="subvalue">Branch Code: {branchCode}</div>,
    formatter: ({ address }) => address
  },
  {
    headerName: 'Media Type',
    isSort: false,
    sortType: null,
    key: 'mediaType',
    subCell: subCellConfigurationTypeForMediaType
  },
  {
    headerName: <Tooltip message={'Annual Recurring Charge'}>ARC</Tooltip>,
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'RECURRING_PRICE',
    key: 'arp',
    formatter: ruppeeFormatter
  },
  {
    headerName: <Tooltip message={'One Time Charge'}>OTC</Tooltip>,
    isSort: false,
    sortType: null,
    key: 'otc',
    formatter: ruppeeFormatter
  }
];
